import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e37b3752"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cost-standards" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tabs = _resolveComponent("tabs")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_tabs, {
      tabs: _ctx.tabs,
      "is-sub-tab": ""
    }, null, 8, ["tabs"]),
    _createElementVNode("div", null, [
      _createVNode(_component_router_view)
    ])
  ]))
}